import CollaboratorsPage from '@ProjectPages/CollaboratorsPage';

export default function TeamsUsersPage() {
    return <CollaboratorsPage />;
}